/* import __COLOCATED_TEMPLATE__ from './user-summary-user.hbs'; */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";

@tagName("li")
export default class UserSummaryUser extends Component {}
